import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="centered">
      <div className="card">
        <h1>Page not found</h1>
        <Link to="/">Back to Today</Link>
      </div>
    </div>
  )
}
